// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"jK-z","carouselContainer":"kK-z"};